import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CRMType } from 'src/app/user-profile/shared/models';

@Component({
  selector: 'app-crm-synchronization-conversation',
  templateUrl: './crm-synchronization-conversation.component.html',
  styleUrls: ['./crm-synchronization-conversation.component.scss'],
})
export class CrmSynchronizationConversationComponent {
  @Input() crmType: CRMType;
  @Input() configuration: any;
  @Input() freshData: any;
  @Input() organizationId: any;
  @Input() conversationSyncFrequencies: any = [];
  @Input() triggerMsgRoutedToCrmTeam: any;
  @Input() triggerMsgRepliedByAgentAndUserMatched: any;
  @Output() agentWorkflowChanged: EventEmitter<any> = new EventEmitter();
  @Output() zendeskContinuousSynchronizationChanged: EventEmitter<any> = new EventEmitter();
  @Output() workflowMappingFromAlcmeonToSalesforceChanged: EventEmitter<any> = new EventEmitter();
  @Output() workflowMappingFromSalesforceToAlcmeonChanged: EventEmitter<any> = new EventEmitter();
}
